module.exports = __webpack_public_path__ + "img/communication.382e295a.jpg";